import { connect } from 'react-redux';
import { compose } from 'recompose';
import { IRootState } from '../../../typings';
import { fetchTournamentAwards } from '../actions';
import { ITournamentAward } from '../typings';

interface IOwnProps {
  tournamentId: string;
}

const mapStateToProps = (state: IRootState) => ({
  award: state.tournamentAwards.list[0] as ITournamentAward,
  fetching: state.tournamentAwards.fetching as boolean,
});

const mapDispatchToProps = {
  fetchTournamentAwards,
};

export type IComponentProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  IOwnProps;

export const connector = compose<IComponentProps, IOwnProps>(
  connect(mapStateToProps, mapDispatchToProps)
);
